import { render, staticRenderFns } from "./IP_HCCSummaryV28.vue?vue&type=template&id=68dd5a86&scoped=true&"
import script from "./IP_HCCSummaryV28.vue?vue&type=script&lang=js&"
export * from "./IP_HCCSummaryV28.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd5a86",
  null
  
)

export default component.exports